const BACKEND =
  process.env.REACT_APP_BACKEND_URL ||
  (typeof window !== 'undefined' && window.location.port === '3000'
    ? 'http://localhost:5000'
    : '');

const API = `${BACKEND}/api`;

const get = async path => {
  const res = await fetch(`${API}${path}`);
  if (!res.ok) throw new Error(res.status === 404 ? 'not-found' : 'Could not load content.');
  return res.json();
};

export const publicApi = {
  posts: params => get(`/blog/posts?${params}`),
  post: slug => get(`/blog/posts/${slug}`),
  caseStudies: params => get(`/case-studies?${params}`),
  caseStudy: slug => get(`/case-studies/${slug}`),
};

export const mediaUrl = value => (value && value.startsWith('/api/') ? `${BACKEND}${value}` : value);

export const formatPostDate = iso => (iso ? new Date(iso).toLocaleDateString('en-CA', { year: 'numeric', month: 'long', day: 'numeric' }) : '');
